import { mediaQuery } from 'common/theme/media';
import styled, { css } from 'styled-components';

export const Mobile = css``;
export const Tablet = css`
    .ticket-list {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .mobile-reverse {
        flex-direction: column-reverse;
    }
    .faq {
        padding: 30px 0;
    }

    .bus-box-2-list {
        flex-direction: column;
        a {
            width: 100%;
        }
    }
    .feature-box-list {
        flex-direction: column;
        gap: 0;
        .box {
            width: 100%;
            .title {
                font-size: 12px;
            }
            .description {
                font-size: 10px;
            }
        }
    }
    .paper {
        padding: 24px;
        margin-top: 30px;
    }
    .post-grid {
        gap: 24px;
        &.column3 {
            .post {
                width: calc(50% - 15px) !important;
            }
        }
    }
    .category-box-list {
        gap: 15px;
        flex-direction: row;
        padding: 30px 0;
        .box {
            flex: 1;
            flex-direction: column;
            min-width: 0;
            min-height: 120px;
        }
    }
`;
export const Styled = styled.div`
    .color-0 {
        color: #ff5722;
    }
    .color-1 {
        color: #4caf50;
    }
    .color-2 {
        color: #2196f3;
    }
    .color-3 {
        color: #9c27b0;
    }
    .color-4 {
        color: #ff9800;
    }
    .custom-header {
        & > * {
            min-height: 550px;
        }
    }
    .banner {
        display: flex;
        padding-top: 40px;
        align-items: center;
        justify-content: center;
    }

    .banner-box {
        max-width: 100%;
        max-height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .banner-box img {
        max-width: 100%;
        height: auto;
        display: block;
        border-radius: 16px;
    }
    .ticket-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px 24px;
        margin: auto;
        margin-bottom: 42px;
        .overflow-hidden {
            overflow: hidden;
            filter: drop-shadow(4px 4px 42px rgba(0, 0, 0, 0.1));
        }
    }
    .category-box-list {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 40px;
        padding: 30px;
        .box {
            cursor: pointer;
            user-select: none;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 5px;
            background-color: #fff;
            border-radius: 16px;
            min-width: 250px;
            padding: 10px;
            color: #303641;
            filter: drop-shadow(4px 4px 42px rgba(0, 0, 0, 0.1));
            transition: all 0.3s;
            &:hover {
                transform: scale(1.05);

                .circle {
                    transform: rotate(-50deg) scale(1.1);
                }
            }

            .title {
                text-align: center;
                color: #303641;
                font-size: 16px;
                font-weight: 400;
            }
            .icon {
                width: 48px;
                height: 48px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                span:not(.circle) {
                    font-size: 24px;
                }
                .circle {
                    transition: all 0.6s;
                    position: absolute;
                    z-index: 0;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                }
            }
        }
    }

    .paper,
    .paper-about {
        background-color: #fff;
        border-radius: 16px;
        padding: 40px;
        height: 100%;
        color: #303641;
        filter: drop-shadow(4px 4px 42px rgba(0, 0, 0, 0.03));

        &[data-padding='small'] {
            padding: 20px;
        }
        .editor {
        }
    }
    .feature-box-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
        .box {
            width: calc(50% - 10px);
            padding: 5px;
            display: flex;
            flex-direction: row;
            gap: 10px;
            .icon {
                border-radius: 6px;
                min-width: 32px;
                width: 32px;
                min-height: 32px;
                height: 32px;
                background-color: #f0f4f9;
                color: var(--mui-palette-primary-main);
                display: flex;
                justify-content: center;
                align-items: center;
                span {
                    font-size: 20px;
                }
            }
            .content {
                .title {
                    font-size: 14px;
                    color: #303641;
                    font-weight: 600;
                }
                .description {
                    font-size: 12px;
                    color: #646a76;
                }
            }
        }
    }

    .faq {
        border-radius: 16px;
        margin: auto;
        background-color: #fff;
        padding: 30px;
        .faq-body {
            margin: auto;
        }
    }
    .bus-box {
        &:first-child {
            margin-bottom: 30px;
        }
        &-title {
            color: #303641;
            font-size: 16px;
            font-weight: 600;
            margin-top: 5px;
        }
        &-list {
            margin-top: 22px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 20px;
            &-section {
                filter: drop-shadow(4px 4px 42px rgba(0, 0, 0, 0.1));
                color: #303641;
                padding: 10px;
                text-decoration: none;
                width: calc(50% - 10px);
                display: block;
                position: relative;
                background-color: #fff;
                border-radius: 16px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: start;
                gap: 5px;
                border: solid 1px transparent;
                transition: all 0.4s;

                .from-to {
                    font-size: 14px;
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    justify-content: start;
                    align-items: start;
                    gap: 7px;
                    width: 100%;
                    color: #303641;
                    .material-icons {
                        transform: rotate(90deg);
                        font-size: 14px;
                    }
                    *:not(.material-icons) {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: calc(100% - 6px);
                    }
                }
                .price {
                    font-size: 16px;
                    font-weight: 700;
                    display: flex;
                    justify-content: start;
                    align-items: end;
                    small {
                        font-weight: 600;
                        font-size: 10px;
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        margin-bottom: 2px;
                        .material-icons {
                            font-size: 10px;
                        }
                    }
                }
                .arrow {
                    position: absolute;
                    right: 10px;
                    bottom: 10px;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #f8f9fc;
                    border-radius: 100%;
                    transition: all 0.3s;
                    .material-icons {
                        font-size: 14px;
                    }
                }
            }
        }
        &.primary {
            .price {
                color: var(--mui-palette-primary-main);
            }
            .bus-box-list-section:hover {
                border-color: var(--mui-palette-primary-main);
                .arrow {
                    background-color: var(--mui-palette-primary-main);
                    color: #fff;
                }
            }
        }
        &.secondary {
            .price {
                color: var(--mui-palette-secondary-main);
            }
            .bus-box-list-section:hover {
                border-color: var(--mui-palette-secondary-main);
                .arrow {
                    background-color: var(--mui-palette-secondary-main);
                    color: #fff;
                }
            }
        }
    }
    .bus-box-2 {
        &-title {
            color: #303641;
            font-size: 16px;
            font-weight: 600;
            margin-top: 5px;
        }
        &-list {
            margin-top: 22px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 20px;
            &-section {
                color: #303641;
                padding: 20px 15px;
                text-decoration: none;
                width: calc(50% - 10px);
                display: block;
                position: relative;
                background-color: #eeeeee;
                border-radius: 12px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: start;
                gap: 5px;
                border: solid 1px transparent;
                transition: all 0.4s;

                .from-to {
                    font-size: 14px;
                    display: flex;
                    justify-content: start;
                    align-items: center;
                    gap: 7px;
                    width: 100%;
                    color: #303641;
                    .material-icons {
                        transform: rotate(90deg);
                        font-size: 14px;
                    }
                    *:not(.material-icons) {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: calc(50% - 16px);
                    }
                }
                .price {
                    font-size: 16px;
                    font-weight: 700;
                    display: flex;
                    justify-content: start;
                    align-items: end;
                    small {
                        font-weight: 600;
                        font-size: 10px;
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        margin-bottom: 2px;
                        .material-icons {
                            font-size: 10px;
                        }
                    }
                }
                .arrow {
                    position: absolute;
                    right: 10px;
                    bottom: 10px;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #f8f9fc;
                    border-radius: 100%;
                    transition: all 0.3s;
                    .material-icons {
                        font-size: 14px;
                    }
                }
            }
        }
        &.primary {
            .price {
                color: var(--mui-palette-primary-main);
            }
            .bus-box-2-list-section:hover {
                background-color: #e3f1f6;
                .arrow {
                    background-color: var(--mui-palette-primary-main);
                    color: #fff;
                }
            }
        }
        &.secondary {
            .price {
                color: var(--mui-palette-secondary-main);
            }
            .bus-box-2-list-section:hover {
                background-color: #fff4e5;
                .arrow {
                    background-color: var(--mui-palette-secondary-main);
                    color: #fff;
                }
            }
        }
    }
    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
    ${mediaQuery.lessThan('mobile')`${Mobile}`}
`;
